import { useEffect } from 'react';
import {
  Show,
  SimpleShowLayout,
  useRecordContext,
  TopToolbar,
  EditButton,
  useRefresh,
} from 'react-admin';
import { Box, Card, CardContent, Grid, Typography, Chip } from '@mui/material';
import { MessageList } from '../../components/support/MessageList';
import { MessageForm } from '../../components/support/MessageForm';
import { StatusChip } from '../../components/support/StatusChip';
import { PriorityChip } from '../../components/support/PriorityChip';
import { AssignButton } from '../../components/support/AssignButton';

const TicketShowActions = () => (
  <TopToolbar>
    <AssignButton />
    <EditButton />
  </TopToolbar>
);

export const TicketShow = () => {
  const refresh = useRefresh();

  // Auto-refresh every 10 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      refresh();
    }, 10000);

    return () => clearInterval(interval);
  }, [refresh]);

  return (
    <Show actions={<TicketShowActions />}>
      <SimpleShowLayout>
        <TicketHeader />
        <TicketChat />
      </SimpleShowLayout>
    </Show>
  );
};

const TicketHeader = () => {
  const record = useRecordContext();

  if (!record) return null;

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h5">{record.subject}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              From: @{record.username || 'N/A'} ({record.first_name})
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Ticket #{record.id} • Created {new Date(record.created_at).toLocaleString()}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
              <StatusChip record={record} source="status" />
              <PriorityChip record={record} source="priority" />
              {record.assigned_username && (
                <Chip label={`Assigned to: ${record.assigned_username}`} color="info" />
              )}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const TicketChat = () => {
  const record = useRecordContext();

  if (!record) return null;

  return (
    <Box>
      <Card>
        <CardContent>
          <MessageList messages={record.messages || []} />
        </CardContent>
      </Card>

      {record.status !== 'closed' && (
        <Box sx={{ mt: 2 }}>
          <MessageForm ticketId={record.id} />
        </Box>
      )}
    </Box>
  );
};
